import ApiService from "@/core/services/api.service";
import {API_URL} from '@/common/config.js'

const apiService = ApiService;


export default class BookService {

    #api = null;

    constructor() {
        this.#api = `${API_URL}user/library/book`;

    }

    paginate(data = null, index = null) {
        let url = `${this.#api}`;
        if (index)
            data.page = index;
        let param = {
            params: data
        }
        return apiService.query(url, param);
    }

    searchBook(key) {
        let url = `${this.#api}/active/${key}/all`
        return apiService.get(url);
    }
    filterBook(data=null){
        let url = `${this.#api}/active/filter/all`;

        let param = {
            params: data
        }
        return apiService.query(url, param);
    }

    update(id, data) {
        let url = `${this.#api}/${id}/update`
        return apiService.post(url, data);

    }

    store(data) {
        let url = `${this.#api}`
        return apiService.post(url, data);

    }

    show(id) {
        let url = `${this.#api}/${id}`
        return apiService.get(url);
    }

    sort(data) {
        let url = `${this.#api}/sort`;
        return apiService.post(url, data);
    }


    delete(id) {
        let url = `${this.#api}/${id}`
        return apiService.delete(url);
    }

    validateBookBarCode(barcode) {
        let url = `${this.#api}/${barcode}/validate`
        return apiService.get(url);
    }

    updateByBarcodeNo(barcodeNo, data) {
        let url = `${this.#api}/barcode/${barcodeNo}/update`
        return apiService.post(url, data);
    }

    getActiveBooksWithAccessions() {
        let url = `${this.#api}/books/active/with-accession`
        return apiService.post(url, data);
    }

    uploadBookImage(bookId, data) {
        let url = `${this.#api}/${bookId}/save/image`
        return apiService.post(url, data);
    }

    getActive() {
        let url = `${this.#api}/active/all`
        return apiService.get(url);
    }
    getNames() {
        let url = `${API_URL}user/library/books/names`
        return apiService.get(url);
    }
    bookStats(){
        let url = `${API_URL}user/library/stats/books`;
        return apiService.get(url);
    }
    getLibraryStat() {
        let url = `${this.#api}/counter-stats`;
        return apiService.get(url);
    }
    getTopIssuedBookStat(data={}) {
        let url = `${this.#api}/top-book-issued/stats`;
        let param = {
            params: data
        }
        return apiService.query(url, param);
    }
    getLibraryBookStatForGraph(data={}) {
        let url = `${this.#api}/issued-returned/graph-stats`;
        let param = {
            params: data
        }
        return apiService.query(url, param);
    }
    getLibrarySummaryStat() {
        let url = `${this.#api}/summary/book-stats`;
        return apiService.get(url);
    }
    exportBooksToCsv(data={}){
        let url = `${this.#api}/export`;
        let param ={
            params: data
        }
        return apiService.query(url,param);
    }


}